import isPropValid from '@emotion/is-prop-valid';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { selectThemeMode } from '@store/app/selectors';
import muiTheme from '@themes/muiTheme';
import theme from '@themes/theme';
import { FC, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { StyleSheetManager, ThemeProvider } from 'styled-components';

import 'react-dropzone-uploader/dist/styles.css';

import Loading from '../Loading';
import NotificationModal from '../NotificationModal';
import PMCARoutes from '../PmcaRoutes';
import ToastCloseButton from '../Toast/components/ToastCloseButton';

import {
  StyledAutocompletePopper,
  StyledDatePicker,
  StyledToastContainer,
  StyledTooltip,
} from './styles';

const StyledApp: FC = () => {
  const themeMode = useSelector(selectThemeMode);

  return (
    <ThemeProvider theme={{ ...theme[themeMode], mode: themeMode }}>
      <MUIThemeProvider theme={muiTheme}>
        <StyleSheetManager
          enableVendorPrefixes
          shouldForwardProp={(propName, elementToBeRendered) =>
            typeof elementToBeRendered === 'string'
              ? isPropValid(propName)
              : true
          }>
          <Suspense fallback={<Loading size={50} containerMode />}>
            <PMCARoutes />
          </Suspense>
          <NotificationModal />
          <StyledToastContainer
            hideProgressBar
            position="bottom-right"
            theme="dark"
            closeButton={({ closeToast }) => (
              <ToastCloseButton closeToast={closeToast} />
            )}
          />
          <StyledDatePicker />
          <StyledAutocompletePopper />
          <StyledTooltip />
        </StyleSheetManager>
      </MUIThemeProvider>
    </ThemeProvider>
  );
};

export default StyledApp;
